import {Injectable} from '@angular/core';
import {DataService} from "../../../../services/external-api/data.service";
import {Observable, of} from "rxjs";
import {emptyCatalogItem, emptyCatalogRequest, emptyPriceList, ICatalogItem, ICatalogRequest, IPriceList} from "@retail-data-factory/rdf-angular-types-api";
import {emptyServiceResponse, IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {map} from "rxjs/operators";
import * as moment from 'moment';
import {emptyParty} from "@retail-data-factory/rdf-angular-types-api";
import {RdfCacheService} from "../rdf-data-set/rdf-cache.service";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {emptySchema, ISchema, ISchemaLine} from "@retail-data-factory/rdf-angular-types-api";
import {mockSchemaList} from "./mock-schema";
import {Presenter} from "../../../internal/presenter/presenter";
@Injectable({
  providedIn: 'root'
})
export class ApiCatalogService {


  requestItems: Array<ICatalogItem> = [];

  constructor(
    private dataService: DataService,
    private presenter: Presenter,
    private imageCacheService: RdfCacheService,
    private configurationManager: ConfigurationManager
    ) {
  }

  getItems(): Observable<Array<ICatalogItem>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/articles`,{}).pipe(
      map((result:IServiceResponse)=>{
        return result.report.map(t=>this.mapCatalogItemFromService(t));
      })
    );
  }


  getItem(itemId: string): Observable<ICatalogItem> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${itemId}`, {}).pipe(
      map(result=>{
        if (result.report.length>0) {
          return this.mapCatalogItemFromService(result.report[0]);
        }else {
          return {...emptyCatalogItem};
        }
      })
    );
  }
  getItemImage(itemId: string): Observable<string> {
    const image = this.imageCacheService.getImage(`catalog*${itemId}`);
    if (image) {
      return of(image);
    }
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/articleimage/${itemId}`, {},null,true).pipe(
      map(result=>{
        if (result.report.length>0 && result.report[0]['Image']) {
          const loadedImage = result.report[0]['Image'];
          this.imageCacheService.addImage(`catalog*${itemId}`,loadedImage);
          return loadedImage;
        } else {
          return '';
        }
      })

    );

  }

  /**
   * Создаение товара в каталоге. Так же может создаваться связанный элемент в MDM
   * @param item - товар
   * @param createMdmElement - создавать или нет MDM элемент
   * @param hierId ID иерархии, в которой будет создаваться элемент. Нужен только в случае если уровней в иерархии больше 1
   * @param parentLevelId ID уровня родителя. Нужен только в случае если уровней в иерархии больше 1
   * @param parentId ID родителя. Нужен только в случае если уровней в иерархии больше 1
   * @param parentCode Code родителя. Нужен только в случае если уровней в иерархии больше 1
   */
  createItem(item: ICatalogItem, createMdmElement = false, hierId?: string, parentLevelId?: string, parentId?: string, parentCode?: string, elementLevelNum?:string): Observable<IServiceResponse> {
    const body = this.mapCatalogItemToService(item);

    if (createMdmElement) {
      const encodedParentCode = encodeURIComponent(parentCode);
      return this.dataService.postData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${item.id}?create_mdm_element=${createMdmElement}&hier_id=${hierId}&parent_level_id=${parentLevelId}&parent_id=${parentId}&parent_code=${encodedParentCode}&element_level_num=${elementLevelNum}`, {},body);
    }else {
      return this.dataService.postData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${item.id}`, {},body);
    }
  }


  /**
   * Обновление информации о товаре
   * @param item
   */
  updateItem(item: ICatalogItem, createMdmElement = false, hierId?: string, parentLevelId?: string, parentId?: string, parentCode?: string, elementLevelNum?:string): Observable<IServiceResponse> {
    const body = this.mapCatalogItemToService(item);

    if (createMdmElement) {
      const encodedParentCode = encodeURIComponent(parentCode);
      return this.dataService.putData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${item.id}?create_mdm_element=${createMdmElement}&hier_id=${hierId}&parent_level_id=${parentLevelId}&parent_id=${parentId}&parent_code=${encodedParentCode}&element_level_num=${elementLevelNum}`, {},body);
    }else {
      return this.dataService.putData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${item.id}`, {},body);
    }
  }

  /**
   * Удалить товар
   * @param itemId
   */
  deleteItem(itemId: string): Observable<IServiceResponse> {
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/article/${itemId}`, {}).pipe(
      map((result: IServiceResponse) => {
        return result;
      })
    );
  }

  getPriceLists(dateFrom?: Date, dateTo?: Date): Observable<Array<IPriceList>> {
    const param = {
      datefrom: dateFrom?moment(dateFrom).format('YYYYMMDD'):'20200101',
      dateto: dateTo?moment(dateTo).format('YYYYMMDD'):moment().format('YYYYMMDD')
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/pricelist`, param).pipe(
      map(result => {
        const priceLists: Array<IPriceList> = result.report.map(item => this.mapPriceListFromService(item));
        return priceLists;
      })
    );
  }
  getPriceListsForDistributor(distributorId?: string, dateFrom?: Date, dateTo?: Date): Observable<Array<IPriceList>> {
    const param = {
      datefrom: dateFrom?moment(dateFrom).format('YYYYMMDD'):'20200101',
      dateto: dateTo?moment(dateTo).format('YYYYMMDD'):moment().format('YYYYMMDD')
    };
    if (distributorId) {
      param['partyid']=distributorId;
    }
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiCatalogUrl')}/pricelist`, param).pipe(
      map(result => {
        const priceLists: Array<IPriceList> = result.report.map(item => this.mapPriceListFromService(item));
        return priceLists;
      })
    );
  }

  getPriceList(): Observable<IPriceList> {
    return of({...emptyPriceList});
  }

  createPriceList(priceList: IPriceList): Observable<IServiceResponse> {
    return of({...emptyServiceResponse});
  }

  updatePriceList(priceList: IPriceList): Observable<IServiceResponse> {
    return of({...emptyServiceResponse});
  }

  sendPriceList(): Observable<IServiceResponse> {
    return of({...emptyServiceResponse});
  }





    getSchemaList(partyId?:string):Observable<Array<ISchemaLine>> {
    if (!partyId) {
      return of([...mockSchemaList.filter(t=>t.current.partyId === this.presenter.currentPartyId)]);
    }else {
        return of([...mockSchemaList.filter(t=>t.current.partyId === partyId)]);
    }
  }

  getSchema(id: string): Observable<ISchema> {
    let schema:ISchema = {...emptySchema};

    mockSchemaList.forEach(curr=>{
      if (curr.current.id === id) {
        schema = curr.current;
      }
      curr.versions.forEach( ver =>{
        if (ver.id === id) {
          schema = ver;
        }
      });
    });
    return of({...schema});
  }



  getRequests():Observable<Array<ICatalogRequest>>{
    return of([]);
  }
  getRequest(requestId: string):Observable<ICatalogRequest> {
    return of({...emptyCatalogRequest});
  }











  mapCatalogItemFromService(item: object): ICatalogItem {
    const catalogItem: ICatalogItem = {
      ...emptyCatalogItem,
      id: item['ID'],
      partyId: item['PartyId'],
      isDeleted: item['Deleted']? true: false,

      code: item['Profile'] && item['Profile']['code']?item['Profile']['code']:item['Code'],
      name: item['Profile'] && item['Profile']['name']?item['Profile']['name']:item['Name'],
      ean: item['Profile'] && item['Profile']['ean']?item['Profile']['ean']:item['Ean'],
      brandId: item['Profile'] && item['Profile']['brand']?item['Profile']['brand']:item['Brand'],
      image: '',
      statusCode: item['Profile'] && item['Profile']['item_status']?item['Profile']['item_status']:item['Status'],



      alcoTypeCode: item['Profile'] && item['Profile']['item_type']?item['Profile']['item_type']:'',
      //boxQty: item['Profile'] && item['Profile']['box_qty']?item['Profile']['box_qty']:'',
      //uomBuyCode: item['Profile'] && item['Profile']['uom']?item['Profile']['uom']:'',
      //uomSellCode: item['Profile'] && item['Profile']['uom_sell']?item['Profile']['uom_sell']:'',
      //vatPrc: item['Profile'] && item['Profile']['vatprc']?item['Profile']['vatprc']:0,
      flowCode: item['Profile'] && item['Profile']['flow']?item['Profile']['flow']:'',

      boxQty: item['Profile'] && item['Profile']['box_qty']?item['Profile']['box_qty']:item['BoxQty'],
      uomBuyCode: item['Profile'] && item['Profile']['uom']?item['Profile']['uom']:item['Uom'],
      uomSellCode: item['Profile'] && item['Profile']['uom_sell']?item['Profile']['uom_sell']:item['UomSell'],
      obligAssortment: item['Profile'] && item['Profile']['obligatory_assortment']?item['Profile']['obligatory_assortment']:true,
      vatPrc: item['Profile'] && item['Profile']['vatprc']?item['Profile']['vatprc']:item['Vat'],

      schema: item['Profile']?item['Profile']['schema']:null,
      data: item['Profile'] && item['Profile']['data']?item['Profile']['data']:{}

    };
    return catalogItem;
  }

  mapCatalogItemToService(item:ICatalogItem): object {
    const result = {
      "id": item.id,
      "code": item.code,  ///код
      "name": item.name,  ////название
      "ean": item.ean,    ///осн. штрихкод
      "brand": item.brandId,
      "item_status": item.statusCode,///статус
      "item_type": item.alcoTypeCode,///тип товара
      "flow": item.flowCode,///поток
      "box_qty": item.boxQty,///кол-во в коробке
      "uom": item.uomBuyCode,///ед закупки
      "uom_sell": item.uomSellCode,/// ед продажи
      "base_discount": '0',// баз.скидка
      "vatprc": item.vatPrc
    };
    return result;
  }


  mapPriceListFromService(item: object): IPriceList {
    const priceList: IPriceList = {
      ...emptyPriceList,
      id: item["ID"],
      code: item["Profile"]["header"]["CodePriceList"] ? item["Profile"]["header"]["CodePriceList"] : '',
      name: '',
      description: item["Profile"]["header"]["Description"] ? item["Profile"]["header"]["Description"] : '',

      statusCode: item["Status"] ? item["Status"] : '',
      releaseCode: item["Release"] ? item["Release"] : '',

      owner: {
        ...emptyParty,
        id: item["Profile"]["header"]["seller"]["id"],
        name: item["Profile"]["header"]["seller"]["name"],
        legalId: item["Profile"]["header"]["seller"]["legal_id"],
        kpp: item["Profile"]["header"]["seller"]["kpp"],
        phone: item["Profile"]["header"]["seller"]["phone"],
        legalAddress: item["Profile"]["header"]["seller"]["address"]
      },

      dateCreate: item["Profile"]["header"]["CreationDate"] ? moment(item['Profile']['header']['CreationDate'], 'DD.MM.YYYY').toDate() : null,
      dateStart: item["Profile"]["header"]["ApplicationDate"] ? moment(item['Profile']['header']['ApplicationDate'], 'DD.MM.YYYY').toDate() : null,
      dateEnd: item["Profile"]["header"]["ExpirationDate"] ? moment(item['Profile']['header']['ExpirationDate'], 'DD.MM.YYYY').toDate() : null,

      recipients: item["Profile"]['header']["customer"].map(customer => ({
        ...emptyParty,
        id: customer["id"],
        name: customer["name"]
      })),
      recipientsCount: item['Profile']['header']['customer'] ? item['Profile']['header']['customer'].length : 0,

      items: [],
      itemsCount: item["Profile"]["header"]['TotalItemCnt']
    };
    return priceList;
  }

  decodePriceListCode(priceList: IPriceList): string {
    if (priceList.releaseCode === "CANCELED") {
      return "Отменен";
    }

    switch (priceList.statusCode) {
      case "NEW":
        return "Нoвый";
      case "INPUT":
        return "Принят";
      case "SENT":
        return "Отправлен";
      default:
        return "Неизвестный";
    }
  }
  decodeStatusColor(item: ICatalogItem):string{
    if (item.isDeleted ) return '#ff0000';

    switch (item.statusCode){
      case 'AC': return '#51a251';
      case 'NA': return '#a0a7c0';
      default: return '#B4B6B4';
    }
  }
  decodeStatusName(item: ICatalogItem):string{
    if (item.isDeleted ) return 'Удален';

    switch (item.statusCode){
      case 'AC': return 'Активный';
      case 'NA': return 'Не доступен';
      default: return 'Не определен';
    }
  }

}
